// extracted by mini-css-extract-plugin
export var rowStyle = "aboutme-dark-module--rowStyle--1UK4G";
export var sayingCol = "aboutme-dark-module--sayingCol--6KKAL";
export var sayingText = "aboutme-dark-module--sayingText--tRM8t";
export var saidByText = "aboutme-dark-module--saidByText--mIwXh";
export var aboutMeText = "aboutme-dark-module--aboutMeText--2vo5w";